import { AxiosError } from 'axios';

import { ApiError, isApiErrorPayload } from '@/entities/api-response/types';

export function toApiError(error: unknown): ApiError {
  if (error instanceof ApiError) return error;

  if (error instanceof AxiosError) {
    const data: unknown = error.response?.data;
    if (isApiErrorPayload(data)) return new ApiError(data);

    return new ApiError({
      statusCode: error.response?.status ?? 0,
      timestamp: new Date().toISOString(),
      path: error.config?.url ?? '',
      message: error.message || 'Network error',
    });
  }

  if (isApiErrorPayload(error)) return new ApiError(error);

  return new ApiError({
    statusCode: 0,
    timestamp: new Date().toISOString(),
    path: '',
    message: error instanceof Error ? error.message : 'Unknown error',
  });
}

export function getErrorMessage(error: ApiError): string {
  return error.message;
}
